import styled from 'styled-components';
import { ButtonContainer, SecondaryNavLinkButton } from '../atoms';

const Menu = styled.div`
  margin-bottom: 33px;
`;

const Button = styled((props) => <SecondaryNavLinkButton {...props} />)`
  &.active {
    color: ${({ theme }) => theme.buttons.primary.color};
    background-color: ${({ theme }) => theme.buttons.primary.background};
    border: ${({ theme }) => theme.buttons.primary.border};
    padding: ${({ theme }) => theme.buttons.primary.padding};
  }
`;

type TMenuItem = {
  name: string;
  relativePath: string;
};

const AccountMenu = ({ merchantId }: { merchantId: string }) => {
  const menuItems: ReadonlyArray<TMenuItem> = [
    { name: 'Overview', relativePath: '' },
    { name: 'Products', relativePath: '/products' },
    { name: 'Courses', relativePath: '/courses' },
    { name: 'Contacts', relativePath: '/contacts' }
    // { name: 'Applications', relativePath: '/applications' }
  ];

  return (
    <Menu>
      <ButtonContainer horizontalSpacing="6px" verticalSpacing="12px">
        {menuItems.map((item) => (
          <Button
            to={`/account/${merchantId}${item.relativePath}`}
            end
            key={item.name}
          >
            {item.name}
          </Button>
        ))}
      </ButtonContainer>
    </Menu>
  );
};

export { AccountMenu };
